import ObjectComparer from 'common/services/util/-RFC.ObjectComparer';
import ActionNotifications from 'common/notifications/-RFC.actionNotifications';
import Util from 'common/services/util/-RFC.util';

let _actions = [];
const _serviceDependencies = [];

/**
     * @ngdoc service
     * @name repositories.ActionsRepository
     *
     * @description
     * This class is used to save/add devices objects.
     */
class ActionsRepository {

    constructor() {

        _actions = [];

        this.observableActions = new Rx.BehaviorSubject(_actions);

    }

    /**
         * @ngdoc function
         * @name repositories.ActionsRepository#replace
         * @methodOf repositories.ActionsRepository
         * @function
         *
         * @description
         * This function can be used to replace all stored actions with provided data.
         *
         * @param {Array} data An array with new actions.
         */
    replace(data) {

        _actions = (data || []);
        this.observableActions.onNext(_actions);

    }

    /**
         * @ngdoc function
         * @name repositories.ActionsRepository#getAll
         * @methodOf repositories.ActionsRepository
         * @function
         *
         * @description
         * This function can be used to retrieves all actions from repository.
         *
         * @returns {Array} actions all actions from repository
         */
    getAll() {

        return _actions;

    }

    /**
         * @ngdoc function
         * @name repositories.ActionsRepository#getById
         * @methodOf repositories.ActionsRepository
         * @function
         *
         * @description
         * This function can be used to retrieves a device based on specified id.
         *
         * @param {integer} deviceId id of device
         *
         * @returns {object} a device based on specified id
         */
    getById(deviceId) {

        return _actions
            .find(device => String(device.relationships.device.data.id) === String(deviceId));

    }

    /**
         * @ngdoc function
         * @name repositories.ActionsRepository#update
         * @methodOf repositories.ActionsRepository
         * @function
         *
         * @description
         * This function can be used to update an action from repository
         *
         * @param {object} an action object with new values
         */
    update(action) {

        if (String(action.id)) {

            const indexOfAction = _actions
                .findIndex(_action => String(_action.id) === String(action.id));

            if (indexOfAction >= 0) {

                const flattenDiff = ObjectComparer.getFlattenDiff(_actions[indexOfAction], action);

                ActionNotifications.processUpdate(flattenDiff, _actions[indexOfAction], action);

                if (!angular.equals(flattenDiff, {})) {

                    _actions[indexOfAction] = action;

                    this.observableActions.onNext(_actions);

                }

            } else if (Util.deepFind(action, 'attributes.action_type') === 'logout') {

                ActionNotifications.processUpdate(null, _actions[indexOfAction], action);

            }

        }

    }

    /**
         * @ngdoc function
         * @name repositories.ActionsRepository#add
         * @methodOf repositories.ActionsRepository
         * @function
         *
         * @description
         * This function can be used to add a new action to repository.
         *
         * @param {object} action An action object.
         */
    add(action) {

        const indexOfActions = _actions
            .findIndex(_action => String(_action.id) === String(action.id));

        if (indexOfActions === -1) {

            _actions.push(action);

            this.observableActions.onNext(_actions);

        }

    }

    /**
         * @ngdoc function
         * @name repositories.ActionsRepository#getObservable
         * @methodOf repositories.ActionsRepository
         * @function
         *
         * @description
         * This function can be used to get an observable object for actios repository.
         * @returns {Object} an observable object for actions repository.
         */
    getObservable() {

        return this.observableActions;

    }

}

_serviceDependencies.push(ActionsRepository);

angular.module('services')
    .service('ActionsRepository', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/common/repositories/actionsRepository.js